export const toHexString = (bytes: Uint8Array | null): string => {
    return bytes ? Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('') : '';
};

export const fromHexString = (hex: string | null): Uint8Array | null => {
    if (!hex || hex.length === 0) {
        return null;
    }

    const length = hex.length / 2;
    const result = new Uint8Array(length);

    for (let i = 0; i < length; i++) {
        result[i] = parseInt(hex.substr(i * 2, 2), 16);
    }

    return result;
};
